import { RouteComponentProps, Router } from '@gatsbyjs/reach-router'
import React from 'react'
import styled from 'styled-components'

import { SanityCheckoutMarketingContentFragment } from '../../../graphql/gatsby'
import SharedBuyLayout from '../../../layouts/buy/SharedBuyLayout'
import Head from '../../../layouts/Head'
import { getRouterBasePath, useDispensaryContext } from '../../../lib/dispensaries'
import BuyGlobalStyle from '../layout/BuyGlobalStyle'
import { Confirmation } from './Confirmation'
import MostRecentConfirmation from './MostRecentConfirmation'

const StyledRouter = styled(Router)`
  // expand to fill focus wrapper added by Gatsby
  // ref: https://github.com/gatsbyjs/gatsby/issues/7310
  width: 100%;
  height: 100%;
`

const DefaultRoute: React.FC<RouteComponentProps> = () => {
  return (
    <>
      <Head />
      <BuyGlobalStyle />
      <SharedBuyLayout>
        <MostRecentConfirmation />
      </SharedBuyLayout>
    </>
  )
}

const ConfirmationRoute: React.FC<
  RouteComponentProps & {
    completedAt?: string
    checkoutMarketingContent: SanityCheckoutMarketingContentFragment['sanityCheckoutMarketingContent']
  }
> = ({ completedAt = '', checkoutMarketingContent }) => (
  <>
    <Head />
    <BuyGlobalStyle />
    <SharedBuyLayout>
      <Confirmation completedAt={completedAt} checkoutMarketingContent={checkoutMarketingContent} />
    </SharedBuyLayout>
  </>
)

export interface ConfirmationPageProps {
  checkoutMarketingContent: SanityCheckoutMarketingContentFragment['sanityCheckoutMarketingContent']
}

export const ConfirmationPage: React.FC<ConfirmationPageProps> = ({ checkoutMarketingContent }) => (
  <StyledRouter basepath={getRouterBasePath('/checkout/confirmation', !!useDispensaryContext())}>
    <DefaultRoute path="/" />
    <ConfirmationRoute path=":completedAt" checkoutMarketingContent={checkoutMarketingContent} />
  </StyledRouter>
)
